var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLarr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 8,
    viewBox: "0 0 225 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 2623",
    d: "M224.354 4.35355C224.549 4.15829 224.549 3.84171 224.354 3.64645L221.172 0.464466C220.976 0.269204 220.66 0.269204 220.464 0.464466C220.269 0.659728 220.269 0.976311 220.464 1.17157L223.293 4L220.464 6.82843C220.269 7.02369 220.269 7.34027 220.464 7.53553C220.66 7.7308 220.976 7.7308 221.172 7.53553L224.354 4.35355ZM0 4.5H224V3.5H0V4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLarr);
export default __webpack_public_path__ + "static/media/larr.62f07e4314f81a40caf506889f784f57.svg";
export { ForwardRef as ReactComponent };